import React from 'react';
import { useLinkingSearchModule } from '../../Modules';
import {
  SearchItem,
  createLinkingSearchItem,
  LinkingSearchItemData,
  LinkingSearchItem,
  isLinkingSearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';

export interface LinkingExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'object';
  rightOperand: { symbol_link_id: string };
}

export interface LinkingExpressionModule extends ExpressionModule<LinkingSearchItemData> {
  toTokenData: (item: SearchItem) => LinkingExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => LinkingSearchItem | undefined;
}

export const isLinkingExpressionData = (token: TokenData<unknown>): token is LinkingExpressionData => {
  return (
    token.leftOperand === 'Tickers.name' &&
    token.operator === 'object' &&
    typeof token.rightOperand === 'object' &&
    token.rightOperand != null &&
    'symbol_link_id' in token.rightOperand
  );
};

export const createLinkingExpressionModule = (): LinkingExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isLinkingExpressionData(token)) return undefined;
      return createLinkingSearchItem(token.rightOperand.symbol_link_id);
    },
    toTokenData: item => {
      if (!isLinkingSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'object',
        rightOperand: { symbol_link_id: item.data.linkId },
      };
    },
  };
};

export const useLinkingExpressionSearchModule = (): ExpressionSearchModule => {
  const linkingModule = useLinkingSearchModule();
  return React.useMemo(() => ({ ...linkingModule, expression: createLinkingExpressionModule() }), [linkingModule]);
};
